import { useMemo } from 'react';

import FormHeader from 'components/global/FormHeader';
import { HeaderContainerFormHeader } from 'components/global/styled/FormHeader.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ADVANCE_WMS_MODULE } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';
import PATHS, { mergePaths } from 'utils/paths';

import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';

const PickingExceptionsLogs = () => {
	const defaultSort = useMemo(() => [{ id: 'id', desc: true }], []);

	const columns = useMemo(
		() => [
			{ Header: 'id', accessor: 'id', filterType: FilterType.number, show: false, showCopyButton: true },
			{ Header: 'otoOrderID', accessor: 'orderID', filterType: FilterType.string, showCopyButton: true },
			{ Header: 'productName', accessor: 'name', filterType: FilterType.string, showOnMobile: true },
			{ Header: 'fullName', accessor: 'fullName', filterType: FilterType.string },
			{ Header: 'sku', accessor: 'sku', filterType: FilterType.string },
			{ Header: 'quantity', accessor: 'quantity', filterType: FilterType.float },
			{ Header: 'barcode', accessor: 'barcode', filterType: FilterType.string },
			{
				Header: 'type',
				accessor: 'type',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{ Header: 'waveId', accessor: 'waveId', filterType: FilterType.string, showCopyButton: true },
			{
				Header: 'recordTime',
				accessor: 'recordTime',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},
			{ Header: 'description', accessor: 'description', filterType: FilterType.string }
		],
		[]
	);

	return (
		<div>
			<HeaderContainerFormHeader>
				<FormHeader
					lightTitle="reports"
					boldTitle="wmsExceptionsLogsListing"
					icon={faArrowLeft}
					backUrl={mergePaths(PATHS.REPORTS, PATHS.OTO_PACK_REPORTS)}
				/>
			</HeaderContainerFormHeader>
			<DynamicList
				id={DYNAMICLISTS.PICKING_EXCEPTIONS}
				defaultSort={defaultSort}
				columns={columns}
				fetchUrl={ADVANCE_WMS_MODULE.GET_PICKING_EXCEPTIONS}
				exportName="pickingNA"
			/>
		</div>
	);
};

export default PickingExceptionsLogs;
